import Components from './../Component';

const FOCUSABLE_ELEMENTS = [
  'a[href]',
  'area[href]',
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
  'select:not([disabled]):not([aria-hidden])',
  'textarea:not([disabled]):not([aria-hidden])',
  'button:not([disabled]):not([aria-hidden])',
  'iframe',
  'object',
  'embed',
  '[contenteditable]',
  '[tabindex]:not([tabindex^="-"])'
];

export default class Sidebar extends Components {
  constructor($) {
    super($);
    console.log('init sidebar');


    //Move to the sidebar if exist
    var mainContent = $('#main-content').detach();
    $('.has-sidebar').prepend(mainContent);


  }

  init(index, element) {

    //Mobile
    this.$(element).find('.title-trigger').on('click', function (e) {
      e.preventDefault();
      this.$(element).find('.title-trigger').toggleClass('closed');
      this.$(element).toggleClass('opened');
    }.bind(this));

    //whean scrollbar arrive at the end of the page, remove the sidebar in mobile
      this.$(window).on('scroll', function() {
        if (this.$(window).scrollTop() + this.$(window).height() >= this.$(document).height()) {
          this.$(element).addClass('hidden');
        }else{
          this.$(element).removeClass('hidden');
        }
      }.bind(this));

    this.$(element).find('ul li a').each(function (i, a) {

      this.$(a).on('click', function (e) {

       //Do only if the href is an anchor
        if (this.$.attr(e.currentTarget, 'href').indexOf('#') == -1) {
          return;
        }

        //get the anchor form url after #
        var anchor = '#'+this.$.attr(e.currentTarget, 'href').split('#')[1];

        //this.setFocusToFirstNode(this.$.attr(e.currentTarget, 'href'));
        //this.$(this.$.attr(e.currentTarget, 'href')).parent().focus();



        //Check if anchor exist without jquery
        var target = document.querySelector(anchor);
        if (!target) return;

        e.preventDefault();

        this.$('html, body').animate({
          scrollTop: (this.$(anchor).offset().top - 120)
        }, 500).bind(this);






      }.bind(this));
    }.bind(this));

    /*
    this.$(window).bind('hashchange', function(e) {
        var hash = window.location.hash.replace(/^#/,'');
        e.preventDefault();
    });*/
  }

  scroll(index, element) {
    /*PERCENT AND ACTIVE*/
    var middlePoint = (this.$(window).height() / 2) + this.$(window).scrollTop();
    var k = 0;
    this.$(element).parent().find('.has-sidebar > *').each(function (i, section) {
      var point = this.$(window).height() - (this.$(section).offset().top - this.$(window).scrollTop());
      var scrollPercent = (point / (this.$(section).height())) * 100;
      if (scrollPercent > 100) scrollPercent = 100;
      this.$(element).find('ul li').eq(i-1).find('.scroll-progression-bar').css('width', scrollPercent + "%");

      if (this.$(section).offset().top < middlePoint) {
        k = i;
      }
    }.bind(this));

    if (this.$(element).find('.scroll-progression-bar').length > 0) {
      //Loop through all the sections and add or remove the active class
      this.$(element).find('ul li').each(function (i, li) {
        //Detect scroll-progress-bar width
        if (this.$(li).find('.scroll-progression-bar').width() > 0) {
          this.$(li).addClass('active');
        } else {
          this.$(li).removeClass('active');
        }
      }.bind(this));
    }
  }

  resize(index, element) {
    /*STICKY*/
    this.$(element).find('.sidebar-container').unstick();
    if (this.$(window).width() > 991 && this.$(element).find('ul').height() < this.$(window).height()) {
      this.$(element).find('.sidebar-container').sticky({
        topSpacing: 100,
        bottomSpacing: this.$('body').height() - (this.$(element).parent().find('.has-sidebar').offset().top + this.$(element).parent().find('.has-sidebar').height()),
        getWidthFrom: this.$(element)
        //bottomSpacing: this.$(element).parent().find('.has-sidebar').position().top + this.$(element).parent().find('.has-sidebar').height()
      }).bind(this);
    }


  }

  getFocusableNodes (id) {
    const nodes = document.querySelector(id).querySelectorAll(FOCUSABLE_ELEMENTS);
    console.log(document.querySelector(id));
    return Array(...nodes);
  }

  setFocusToFirstNode (id) {

    const focusableNodes = this.getFocusableNodes(id)

    // no focusable nodes
    if (focusableNodes.length === 0) return

    // remove nodes on whose click, the modal closes
    // could not think of a better name :(
    const nodesWhichAreNotCloseTargets = focusableNodes.filter(node => {
      //return !node.hasAttribute(this.config.closeTrigger)
      return true
    })

    setTimeout(function(){
      if (nodesWhichAreNotCloseTargets.length > 0) { nodesWhichAreNotCloseTargets[0].focus() }
      if (nodesWhichAreNotCloseTargets.length === 0) { focusableNodes[0].focus() }
    }, 100);

  }

}
